import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Users, MapPin, Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

/* import kimag1 from '../assest/capms/Kondaveedu/image1.png';
 */import kimag2 from '../assest/capms/Kondaveedu/image2.png';
import kimag3 from '../assest/capms/Kondaveedu/image3.png';
import kimag4 from '../assest/capms/Kondaveedu/image4.png';

import Bimg1 from '../assest/capms/Bhavanipuram/image1.png';
import Bimg2 from '../assest/capms/Bhavanipuram/image2.png';
import Bimg3 from '../assest/capms/Bhavanipuram/image3.png';
import Bimg4 from '../assest/capms/Bhavanipuram/image4.png';

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1 }
  }
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1 }
  }
};

const ImageGallery = ({ images, alt }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = (e) => {
    e.preventDefault();
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = (e) => {
    e.preventDefault();
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  return (
    <div className="relative h-56 w-full group/gallery overflow-hidden">

      {/* IMAGE SLIDE */}
      <motion.div
        key={currentIndex}
        className="flex h-full"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        style={{
          transform: `translateX(-${currentIndex * 100}%)`
        }}
      >
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`${alt} - ${index + 1}`}
            className="w-full h-full object-cover flex-shrink-0"
          />
        ))}
      </motion.div>

      {/* ARROWS */}
      <motion.button
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        onClick={prevImage}
        className="absolute left-2 top-1/2 bg-black/50 p-1 rounded-full text-white opacity-0 group-hover/gallery:opacity-100 transition-opacity hover:bg-blue-500"
      >
        <ChevronLeft size={20} />
      </motion.button>

      <motion.button
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        onClick={nextImage}
        className="absolute right-2 top-1/2 bg-black/50 p-1 rounded-full text-white opacity-0 group-hover/gallery:opacity-100 transition-opacity hover:bg-blue-500"
      >
        <ChevronRight size={20} />
      </motion.button>

      {/* DOTS */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
        {images.map((_, index) => (
          <div
            key={index}
            className={`h-1.5 rounded-full transition-all ${
              currentIndex === index
                ? "w-4 bg-teal-400"
                : "w-1.5 bg-white/50"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

const Camps = () => {
  const camps = [
    {
      location:
        "Free Dental Camp held at Kondaveedu Academy Kalyana Mandapam, Bhavanipuram, Vijayawada",
      date: "22-02-2026",
      patients: "250+",
      type: "Education & Checkup",
      images: [kimag2, kimag3, kimag4],
    },
    {
      location:
        "Free Dental Checkup and Oral Health Awareness Camp held at SKCV Children’s Trust, Bhavanipuram, Vijayawada",
      date: "16-11-2025",
      patients: "500+",
      type: "Education & Checkup",
      images: [Bimg1, Bimg2, Bimg3, Bimg4],
    },
  ];

  return (
    <motion.section
      className="pt-12 pb-12 bg-slate-900 text-white scroll-mt-28 xl:pb-24 2xl:pb-[250px]"
      id="camps"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">

        {/* HEADER */}
        <motion.div
          className="flex flex-col md:flex-row justify-between items-end mb-2"
          variants={fadeUp}
        >
          <div>
            <span className="text-[#3d60ad] font-bold tracking-widest uppercase text-sm">
              Social Responsibility
            </span>

            <h2 className="text-4xl font-black mt-2">
              Free Dental Camps
            </h2>
          </div>
        </motion.div>

        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10">

          {camps.map((camp, i) => (
            <motion.div
              key={i}
              className="group bg-slate-800 rounded-3xl border border-slate-700 hover:border-[#3d60ad] transition-all overflow-hidden flex flex-col w-full"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              whileHover={{ y: -8, scale: 1.02 }}
            >
              {/* IMAGE */}
              <ImageGallery images={camp.images} alt={camp.location} />

              {/* CONTENT */}
              <div className="p-8 flex-grow">

                <div className="flex justify-between items-start mb-6 w-full">

                  <motion.div
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    className="bg-[#3d60ad]/10 p-3 rounded-xl"
                  >
                    <MapPin className="text-[#3d60ad]" />
                  </motion.div>

                  <span className="bg-[#3d60ad] text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                    {camp.type}
                  </span>

                </div>

                <h3 className="text-xl font-bold mb-4 line-clamp-2 h-14">
                  {camp.location}
                </h3>

                <div className="flex items-center gap-4 text-slate-400 text-sm mt-auto">

                  <span className="flex items-center gap-1">
                    <Calendar size={14} className="text-[#3d60ad]/50" />
                    {camp.date}
                  </span>

                  <span className="flex items-center gap-1">
                    <Users size={14} className="text-[#3d60ad]/50" />
                    {camp.patients} Treated
                  </span>

                </div>

              </div>
            </motion.div>
          ))}

        </div>
      </div>
    </motion.section>
  );
};

export default Camps;